import {
  useCreate,
  useDelete,
  useDetail,
  useList,
  useUpdate,
  usePartialUpdate,
} from '@inmagik/react-crud'
import { Cliente } from '../types'
import { API_URL } from '../constants'

export function useClientiList(params: Record<string, string> = {}) {
  return useList<Cliente>(`${API_URL}/bilance/cliente`, params)
}

export function useCliente(id: string, enabled: boolean = true) {
  return useDetail<Cliente>(`${API_URL}/bilance/cliente`, id, { enabled })
}

export function useCreateCliente() {
  return useCreate<Cliente>(`${API_URL}/bilance/cliente`)
}

export function useUpdateCliente() {
  return useUpdate<Cliente>(`${API_URL}/bilance/cliente`)
}

export function useDeleteCliente() {
  return useDelete(`${API_URL}/bilance/cliente`)
}

export function usePartialUpdateCliente() {
  return usePartialUpdate<Cliente>(`${API_URL}/bilance/cliente`)
}